/**
 * @module components/Tooltip
 * @description Tooltip component wrapper for react-tooltip library.
 * Provides consistent tooltip styling and positioning with default bottom placement.
 */

import React from 'react';
import { REACT_TOOLTIP_Z_INDEX } from 'src/utils';
import * as Styles from './styles';
import type { TooltipProps } from './types';
import { TooltipPlace } from './types';

/**
 * Default tooltip styles applied to all tooltips.
 * Sets z-index to ensure tooltips appear above other content.
 */
export const tooltipStyles = {
  zIndex: REACT_TOOLTIP_Z_INDEX,
};

export const Tooltip: React.FC<TooltipProps> = ({ className, place = TooltipPlace.BOTTOM, style, ...rest }) => {
  return (
    <Styles.Tooltip className={className} place={place} style={{ ...tooltipStyles, ...style }} {...rest} />
  );
};

export { TooltipPlace } from './types';
export type { TooltipProps } from './types';
